import { createState } from "@hookstate/core";
import { Product } from "./app/interfaces/Product";

export const store = createState("");

export const formIdStore = createState('');

export const productStore = createState({} as Product);